var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pdp-set-picker" },
    [
      _c("div", { staticClass: "pdp-set-picker__header" }, [
        _c("div", { staticClass: "pdp-set-picker__header-row" }, [
          _c("div", { staticClass: "pdp-set-picker__title" }, [
            _vm._v("\n        Building a PDP image set for "),
            _c("b", [_vm._v(_vm._s(_vm.productLabel || "your product"))]),
            _vm._v(".\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pdp-set-picker__bulk" }, [
            _c(
              "button",
              {
                staticClass: "pdp-set-picker__bulk-btn",
                attrs: { type: "button", disabled: _vm.disabled },
                on: {
                  click: function ($event) {
                    return _vm.setAll("ai")
                  },
                },
              },
              [
                _c("i", { staticClass: "bi bi-stars" }),
                _vm._v(" All AI\n        "),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "pdp-set-picker__bulk-sep" }, [
              _vm._v("·"),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "pdp-set-picker__bulk-btn",
                attrs: {
                  type: "button",
                  disabled: _vm.disabled || !_vm.anyTemplatesAvailable,
                },
                on: {
                  click: function ($event) {
                    return _vm.setAll("gallery")
                  },
                },
              },
              [
                _c("i", { staticClass: "bi bi-image" }),
                _vm._v(" All Gallery\n        "),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.referenceMode
          ? _c("p", { staticClass: "pdp-set-picker__subtitle" }, [
              _vm._v("\n      One card per reference image — each\n      "),
              _vm._m(0),
              _vm._v(
                "\n      card shows the source it'll be based on. Reorder, remove, or add cards, then\n      create your set.\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pdp-set-picker__controls" }, [
        !_vm.referenceMode
          ? _c(
              "div",
              {
                staticClass: "pdp-set-picker__preset",
                class: { "is-open": _vm.presetOpen },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "pdp-set-picker__preset-trigger",
                    attrs: { type: "button", disabled: _vm.disabled },
                    on: { click: _vm.togglePresetDropdown },
                  },
                  [
                    _c("i", {
                      staticClass:
                        "bi bi-soundwave pdp-set-picker__preset-icon",
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "pdp-set-picker__preset-value" },
                      [
                        _vm._v(
                          _vm._s(_vm.activePresetLabel || "Sequence preset...")
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "bi bi-chevron-down pdp-set-picker__preset-chevron",
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.presetOpen,
                        expression: "presetOpen",
                      },
                    ],
                    staticClass: "pdp-set-picker__preset-menu",
                  },
                  _vm._l(_vm.presetSources, function (src) {
                    return _c(
                      "button",
                      {
                        key: src.id,
                        staticClass: "pdp-set-picker__preset-item",
                        class: { "is-active": src.id === _vm.activePresetId },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.selectPreset(src.id)
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(src.label) + " "),
                          _c(
                            "span",
                            { staticClass: "pdp-set-picker__preset-count" },
                            [_vm._v("· " + _vm._s(src.count))]
                          ),
                        ]),
                        _vm._v(" "),
                        src.id === _vm.activePresetId
                          ? _c("i", { staticClass: "bi bi-check-lg" })
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.referenceMode
          ? _c("span", { staticClass: "pdp-set-picker__or" }, [_vm._v("or")])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "pdp-set-picker__reference" }, [
          _c("i", {
            staticClass: "bi bi-search pdp-set-picker__reference-icon",
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "pdp-set-picker__reference-input",
            attrs: {
              type: "text",
              placeholder: "Reference: ASIN, Salsify ID, or product name...",
              disabled: _vm.disabled,
            },
            domProps: { value: _vm.referenceInput },
            on: {
              input: function ($event) {
                _vm.referenceInput = $event.target.value
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _vm.submitReference.apply(null, arguments)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.addableTypes.length
          ? _c("div", { staticClass: "pdp-set-picker__add-image-type" }, [
              _c(
                "button",
                {
                  staticClass: "pdp-set-picker__add-trigger",
                  class: { "is-open": _vm.addableTypesOpen },
                  attrs: { type: "button", disabled: _vm.disabled },
                  on: { click: _vm.toggleAddableTypesDropdown },
                },
                [
                  _c("i", { staticClass: "bi bi-plus-lg" }),
                  _vm._v(" Add image type\n        "),
                  _c("span", [
                    _vm._v("(" + _vm._s(_vm.addableTypes.length) + ")"),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "bi bi-chevron-down pdp-set-picker__add-chevron",
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.addableTypesOpen
                ? _c(
                    "div",
                    { staticClass: "pdp-set-picker__add-dropdown-menu" },
                    _vm._l(_vm.addableTypes, function (t) {
                      return _c(
                        "button",
                        {
                          key: t.key,
                          staticClass: "pdp-set-picker__add-item",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.addRow(t)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          + " + _vm._s(t.label) + "\n        "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.briefId
          ? _c("div", { staticClass: "pdp-set-picker__brief" }, [
              _c(
                "button",
                {
                  staticClass: "pdp-set-picker__brief-btn",
                  attrs: {
                    type: "button",
                    title: `From brief: ${_vm.briefLabel}`,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("open-brief")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "bi bi-file-earmark-text" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "pdp-set-picker__brief-name" }, [
                    _vm._v("From brief: " + _vm._s(_vm.briefLabel)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "pdp-set-picker__brief-open",
                  attrs: {
                    type: "button",
                    "aria-label": "Open the brief",
                    title: "Open the brief",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("open-brief-full")
                    },
                  },
                },
                [_c("i", { staticClass: "bi bi-box-arrow-up-right" })]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "cardsList", staticClass: "pdp-set-picker__grid" },
        _vm._l(_vm.localRows, function (row, rowIdx) {
          return _c(
            "div",
            {
              key: row._uid,
              staticClass: "pdp-set-picker__card",
              class: {
                "is-reference": !!row.reference_image_url,
                "is-popover-open":
                  _vm.galleryOpenIdx === rowIdx ||
                  _vm.directionOpenIdx === rowIdx ||
                  _vm.yoursMenuIdx === rowIdx ||
                  _vm.cardMenuIdx === rowIdx,
              },
            },
            [
              !_vm.disabled
                ? _c(
                    "div",
                    { staticClass: "pdp-set-picker__card-tools" },
                    [
                      _vm.isHeroRow(row)
                        ? [
                            _c(
                              "button",
                              {
                                staticClass: "pdp-set-picker__mode-btn",
                                class: { "is-active": row.mode === "original" },
                                attrs: {
                                  type: "button",
                                  title:
                                    "Original — use the product image as-is",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.pickMode(rowIdx, "original")
                                  },
                                },
                              },
                              [_c("i", { staticClass: "bi bi-image-fill" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "pdp-set-picker__mode-btn",
                                class: { "is-active": row.mode === "ai" },
                                attrs: {
                                  type: "button",
                                  title: "AI — generate a fresh image",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.pickMode(rowIdx, "ai")
                                  },
                                },
                              },
                              [_c("i", { staticClass: "bi bi-stars" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "pdp-set-picker__mode-btn",
                                class: { "is-active": row.mode === "yours" },
                                attrs: {
                                  type: "button",
                                  title:
                                    "Use your own image (upload, File Browser, or Salsify)",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.toggleYoursMenu(rowIdx)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "bi bi-upload" })]
                            ),
                          ]
                        : [
                            _c(
                              "button",
                              {
                                staticClass: "pdp-set-picker__mode-btn",
                                class: { "is-active": row.mode === "ai" },
                                attrs: {
                                  type: "button",
                                  title: "AI — generate a fresh image",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.pickMode(rowIdx, "ai")
                                  },
                                },
                              },
                              [_c("i", { staticClass: "bi bi-stars" })]
                            ),
                            _vm._v(" "),
                            _vm.hasTemplates(row)
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "pdp-set-picker__mode-btn",
                                    class: {
                                      "is-active": row.mode === "gallery",
                                      "is-open": _vm.galleryOpenIdx === rowIdx,
                                    },
                                    attrs: {
                                      type: "button",
                                      title:
                                        "Gallery — pick a pre-designed template",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.toggleGallery(rowIdx)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "bi bi-image" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            row.type === "lifestyle"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "pdp-set-picker__mode-btn",
                                    class: {
                                      "is-active": row.mode === "scene",
                                    },
                                    attrs: {
                                      type: "button",
                                      title:
                                        "Scene — composite into a lifestyle scene",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.pickMode(rowIdx, "scene")
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "bi bi-image-alt" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "pdp-set-picker__mode-btn",
                                class: { "is-active": row.mode === "yours" },
                                attrs: {
                                  type: "button",
                                  title:
                                    "Use your own image (upload, File Browser, or Salsify)",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.toggleYoursMenu(rowIdx)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "bi bi-upload" })]
                            ),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "pdp-set-picker__card-tools-right" }, [
                _vm.isGenerativeRow(row) && _vm.rowEditable(rowIdx)
                  ? _c(
                      "button",
                      {
                        staticClass: "pdp-set-picker__wand",
                        class: {
                          "is-active": _vm.hasDirection(row, rowIdx),
                          "is-open": _vm.directionOpenIdx === rowIdx,
                        },
                        attrs: {
                          type: "button",
                          title: "Add design direction (optional)",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleDirection(rowIdx, $event)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-magic" }),
                        _vm._v(" "),
                        _vm.hasDirection(row, rowIdx)
                          ? _c("span", {
                              staticClass: "pdp-set-picker__wand-dot",
                            })
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.disabled
                  ? _c(
                      "button",
                      {
                        staticClass: "pdp-set-picker__card-menu",
                        class: { "is-open": _vm.cardMenuIdx === rowIdx },
                        attrs: {
                          type: "button",
                          title: "More actions",
                          disabled: _vm.disabled,
                          "aria-label": `More actions for ${row.label}`,
                          "aria-haspopup": "menu",
                          "aria-expanded":
                            _vm.cardMenuIdx === rowIdx ? "true" : "false",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleCardMenu(rowIdx, $event)
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi bi-three-dots-vertical" })]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.cardMenuIdx === rowIdx
                ? _c(
                    "div",
                    {
                      staticClass: "pdp-set-picker__card-menu-pop",
                      class: { "is-above": _vm.cardMenuAbove[rowIdx] },
                      attrs: { role: "menu" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "pdp-set-picker__card-menu-item",
                          attrs: {
                            type: "button",
                            role: "menuitem",
                            disabled: _vm.disabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.duplicateRow(rowIdx)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-copy" }),
                          _vm._v(" Duplicate slot\n        "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "pdp-set-picker__card-menu-item is-danger",
                          attrs: {
                            type: "button",
                            role: "menuitem",
                            disabled: _vm.disabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeRowFromMenu(rowIdx)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-x-lg" }),
                          _vm._v(" Remove\n        "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.galleryOpenIdx === rowIdx
                ? _c(
                    "div",
                    {
                      staticClass: "pdp-set-picker__gallery-pop",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "pdp-set-picker__gallery-pop-head" },
                        [
                          _vm._v(
                            "\n          Choose a " +
                              _vm._s(row.label) +
                              " template\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pdp-set-picker__gallery-pop-grid" },
                        _vm._l(_vm.templatesForRow(row), function (tpl) {
                          return _c(
                            "div",
                            {
                              key: `${row.rowIndex}-${tpl.id}`,
                              staticClass: "pdp-set-picker__gallery-pop-tile",
                              class: {
                                "is-selected":
                                  row.mode === "gallery" &&
                                  row.template_id === tpl.id,
                              },
                              attrs: {
                                role: "button",
                                tabindex: _vm.disabled ? -1 : 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onGalleryPick(rowIdx, tpl)
                                },
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  return _vm.onGalleryPick(rowIdx, tpl)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: { src: tpl.thumbnail, alt: tpl.name },
                              }),
                              _vm._v(" "),
                              row.mode === "gallery" &&
                              row.template_id === tpl.id
                                ? _c("i", {
                                    staticClass:
                                      "bi bi-check-circle-fill pdp-set-picker__gallery-pop-check",
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "pdp-set-picker__gallery-pop-expand",
                                  attrs: {
                                    type: "button",
                                    "aria-label": "Preview template",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.openLightbox(rowIdx, tpl)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-arrows-angle-expand",
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "pdp-set-picker__gallery-pop-browse",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("open-gallery")
                            },
                          },
                        },
                        [_vm._v("\n          Browse full gallery →\n        ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.yoursMenuIdx === rowIdx
                ? _c(
                    "div",
                    {
                      staticClass: "pdp-set-picker__yours-menu",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "pdp-set-picker__yours-menu-head" },
                        [_vm._v("\n          USE YOUR OWN IMAGE\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "pdp-set-picker__yours-menu-item",
                          attrs: { type: "button", disabled: _vm.disabled },
                          on: {
                            click: function ($event) {
                              return _vm.requestOwnImage(rowIdx, "upload")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-upload" }),
                          _vm._v(" Upload from computer...\n        "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "pdp-set-picker__yours-menu-item",
                          attrs: { type: "button", disabled: _vm.disabled },
                          on: {
                            click: function ($event) {
                              return _vm.requestOwnImage(rowIdx, "browser")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-folder2-open" }),
                          _vm._v(" Choose from File Browser...\n        "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "pdp-set-picker__yours-menu-item",
                          attrs: { type: "button", disabled: _vm.disabled },
                          on: {
                            click: function ($event) {
                              return _vm.requestOwnImage(rowIdx, "salsify")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-bar-chart-steps" }),
                          _vm._v(" Pull from Salsify...\n        "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.directionOpenIdx === rowIdx
                ? _c(
                    "div",
                    {
                      staticClass: "pdp-set-picker__direction",
                      class: {
                        "is-above": _vm.directionAbove[rowIdx],
                        "is-left": _vm.directionLeftAlign[rowIdx],
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "pdp-set-picker__direction-head" },
                        [
                          _c(
                            "span",
                            { staticClass: "pdp-set-picker__direction-title" },
                            [_vm._v("Customize " + _vm._s(row.label))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "pdp-set-picker__direction-optional",
                            },
                            [_vm._v("All optional")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c("textarea", {
                        staticClass: "pdp-set-picker__direction-text",
                        attrs: {
                          rows: "3",
                          placeholder: _vm.directionPlaceholderFor(row),
                          disabled: !_vm.rowEditable(rowIdx),
                        },
                        domProps: { value: row.userInstructions || "" },
                        on: {
                          input: function ($event) {
                            return _vm.setRowDirection(
                              rowIdx,
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pdp-set-picker__direction-section" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pdp-set-picker__direction-section-head",
                            },
                            [
                              _c("FileTextIcon", {
                                attrs: { width: 12, height: 12 },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "pdp-set-picker__direction-label",
                                },
                                [_vm._v("Overlay text")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("textarea", {
                            staticClass: "pdp-set-picker__direction-text",
                            attrs: {
                              rows: "3",
                              placeholder: _vm.overlayTextPlaceholder,
                              disabled: !_vm.rowEditable(rowIdx),
                            },
                            domProps: { value: row.overlayText || "" },
                            on: {
                              input: function ($event) {
                                return _vm.setRowOverlayText(
                                  rowIdx,
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pdp-set-picker__overlay-mode" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "pdp-set-picker__overlay-mode-btn",
                                  class: {
                                    "is-active":
                                      _vm.overlayModeOf(row) === "editable",
                                  },
                                },
                                [
                                  _c("input", {
                                    attrs: {
                                      type: "radio",
                                      name: `overlay-mode-${rowIdx}`,
                                      value: "editable",
                                      disabled: !_vm.rowEditable(rowIdx),
                                    },
                                    domProps: {
                                      checked:
                                        _vm.overlayModeOf(row) === "editable",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.setRowOverlayTextMode(
                                          rowIdx,
                                          "editable"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n              Editable layer\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "pdp-set-picker__overlay-mode-btn",
                                  class: {
                                    "is-active":
                                      _vm.overlayModeOf(row) ===
                                      "part_of_image",
                                  },
                                },
                                [
                                  _c("input", {
                                    attrs: {
                                      type: "radio",
                                      name: `overlay-mode-${rowIdx}`,
                                      value: "part_of_image",
                                      disabled: !_vm.rowEditable(rowIdx),
                                    },
                                    domProps: {
                                      checked:
                                        _vm.overlayModeOf(row) ===
                                        "part_of_image",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.setRowOverlayTextMode(
                                          rowIdx,
                                          "part_of_image"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n              Part of image\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pdp-set-picker__direction-section" },
                        [
                          _c(
                            "div",
                            { staticClass: "pdp-set-picker__ref-tabs" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "pdp-set-picker__ref-tab",
                                  class: {
                                    "is-active":
                                      _vm.refTabFor(rowIdx) === "product",
                                  },
                                  attrs: {
                                    type: "button",
                                    disabled: !_vm.rowEditable(rowIdx),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setRefTab(rowIdx, "product")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Product images\n              "
                                  ),
                                  _vm.productImagesFor(rowIdx).length
                                    ? _c("span", {
                                        staticClass:
                                          "pdp-set-picker__ref-tab-dot",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "pdp-set-picker__ref-tab",
                                  class: {
                                    "is-active":
                                      _vm.refTabFor(rowIdx) === "logo",
                                  },
                                  attrs: {
                                    type: "button",
                                    disabled: !_vm.rowEditable(rowIdx),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setRefTab(rowIdx, "logo")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Brand logo\n              "
                                  ),
                                  _vm.brandLogoByRowIdx[rowIdx]
                                    ? _c("span", {
                                        staticClass:
                                          "pdp-set-picker__ref-tab-dot",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.refTabFor(rowIdx) === "product"
                            ? [
                                _vm._l(
                                  _vm.productImagesFor(rowIdx),
                                  function (img, imgIdx) {
                                    return _c(
                                      "div",
                                      {
                                        key: `${row._uid}-prod-${imgIdx}`,
                                        staticClass:
                                          "pdp-set-picker__logo-selected pdp-set-picker__product-item",
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "pdp-set-picker__logo-thumb-sm",
                                          attrs: { src: img.url },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdp-set-picker__logo-name",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                img.name || "Product image"
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "pdp-set-picker__ref-remove",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.rowEditable(rowIdx),
                                              "aria-label": `Remove ${
                                                img.name || "product image"
                                              }`,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeProductImage(
                                                  rowIdx,
                                                  imgIdx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "bi bi-x-lg",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "pdp-set-picker__ref-dropzone",
                                    class: {
                                      "is-dragover": _vm.dropzoneDragActive,
                                    },
                                    on: {
                                      dragenter: function ($event) {
                                        $event.preventDefault()
                                        _vm.dropzoneDragActive = true
                                      },
                                      dragover: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onDropzoneDragOver($event)
                                      },
                                      dragleave: function ($event) {
                                        return _vm.onDropzoneDragLeave($event)
                                      },
                                      drop: function ($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.onDropImage(
                                          rowIdx,
                                          "product",
                                          $event
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "pdp-set-picker__ref-link",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.rowEditable(rowIdx),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.requestProductImage(
                                              rowIdx,
                                              "upload"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.productImagesFor(rowIdx)
                                                .length
                                                ? "Add more"
                                                : "Upload"
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "pdp-set-picker__ref-sep",
                                      },
                                      [_vm._v(",")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "pdp-set-picker__ref-link",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.rowEditable(rowIdx),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.pasteFromClipboardClick(
                                              rowIdx,
                                              "product"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                paste\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "pdp-set-picker__ref-sep",
                                      },
                                      [_vm._v(", or")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "pdp-set-picker__ref-link",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.rowEditable(rowIdx),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.requestProductImage(
                                              rowIdx,
                                              "browser"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                choose from Files\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "pdp-set-picker__ref-all" },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "checkbox",
                                        disabled:
                                          !_vm.rowEditable(rowIdx) ||
                                          !_vm.productImagesFor(rowIdx).length,
                                      },
                                      domProps: {
                                        checked: _vm.isProductApplyAll(rowIdx),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.toggleProductApplyAll(
                                            rowIdx,
                                            $event.target.checked
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n              Use for all images\n            "
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _vm.brandLogoByRowIdx[rowIdx]
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pdp-set-picker__logo-selected",
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "pdp-set-picker__logo-thumb-sm",
                                          attrs: {
                                            src: _vm.brandLogoByRowIdx[rowIdx]
                                              .url,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdp-set-picker__logo-name",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.brandLogoByRowIdx[rowIdx]
                                                  .name || "Logo"
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "pdp-set-picker__logo-change",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.rowEditable(rowIdx),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.requestBrandLogo(
                                                  rowIdx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Change\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "pdp-set-picker__ref-remove",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.rowEditable(rowIdx),
                                              "aria-label": "Remove brand logo",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeBrandLogo(
                                                  rowIdx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "bi bi-x-lg",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pdp-set-picker__ref-dropzone",
                                        class: {
                                          "is-dragover": _vm.dropzoneDragActive,
                                        },
                                        on: {
                                          dragenter: function ($event) {
                                            $event.preventDefault()
                                            _vm.dropzoneDragActive = true
                                          },
                                          dragover: function ($event) {
                                            $event.preventDefault()
                                            return _vm.onDropzoneDragOver(
                                              $event
                                            )
                                          },
                                          dragleave: function ($event) {
                                            return _vm.onDropzoneDragLeave(
                                              $event
                                            )
                                          },
                                          drop: function ($event) {
                                            $event.preventDefault()
                                            $event.stopPropagation()
                                            return _vm.onDropImage(
                                              rowIdx,
                                              "logo",
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "pdp-set-picker__ref-link",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.rowEditable(rowIdx),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.requestBrandLogo(
                                                  rowIdx,
                                                  "upload"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Upload\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdp-set-picker__ref-sep",
                                          },
                                          [_vm._v(",")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "pdp-set-picker__ref-link",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.rowEditable(rowIdx),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.pasteFromClipboardClick(
                                                  rowIdx,
                                                  "logo"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                paste\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdp-set-picker__ref-sep",
                                          },
                                          [_vm._v(", or")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "pdp-set-picker__ref-link",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.rowEditable(rowIdx),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.requestBrandLogo(
                                                  rowIdx,
                                                  "browser"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                choose from Files\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "separator w-100" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pdp-set-picker__direction-foot" },
                        [
                          _c(
                            "span",
                            { staticClass: "pdp-set-picker__direction-note" },
                            [
                              _vm._v(
                                "Saved automatically · applies only to this image."
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "pdp-set-picker__direction-done",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.directionOpenIdx = null
                                },
                              },
                            },
                            [_vm._v("\n            Done\n          ")]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "pdp-set-picker__card-frame" }, [
                _c("div", { staticClass: "pdp-set-picker__card-body" }, [
                  _vm.cardPreview(row)
                    ? _c("img", {
                        staticClass: "pdp-set-picker__card-img",
                        attrs: { src: _vm.cardPreview(row), alt: row.label },
                      })
                    : _vm.needsOwnImage(row)
                    ? _c(
                        "button",
                        {
                          staticClass: "pdp-set-picker__card-upload",
                          attrs: {
                            type: "button",
                            disabled: !_vm.rowEditable(rowIdx),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleYoursMenu(rowIdx)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-upload" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Upload your image")]),
                        ]
                      )
                    : _c("i", {
                        staticClass: "bi bi-stars pdp-set-picker__card-spark",
                      }),
                ]),
                _vm._v(" "),
                !!row.reference_image_url
                  ? _c(
                      "span",
                      { staticClass: "pdp-set-picker__card-ref-badge" },
                      [
                        _c("i", { staticClass: "bi bi-stars" }),
                        _vm._v(" AI\n        "),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.rowGenerated(rowIdx)
                  ? _c(
                      "span",
                      {
                        staticClass: "pdp-set-picker__card-done",
                        attrs: { title: "Already generated" },
                      },
                      [_c("i", { staticClass: "bi bi-check-lg" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.cardPreview(row)
                  ? _c(
                      "button",
                      {
                        staticClass: "pdp-set-picker__card-expand",
                        attrs: {
                          type: "button",
                          "aria-label": "Preview image",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.openImagePreview(
                              _vm.cardPreview(row),
                              row.label
                            )
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi bi-arrows-angle-expand" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "pdp-set-picker__card-label" }, [
                  _vm._v("\n          " + _vm._s(row.label) + "\n        "),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.showSizeRow
        ? _c("div", { staticClass: "pdp-set-picker__size" }, [
            _c("span", { staticClass: "pdp-set-picker__size-label" }, [
              _vm._v("Image size"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pdp-set-picker__size-options" },
              _vm._l(_vm.sizeOptions, function (opt) {
                return _c(
                  "button",
                  {
                    key: opt,
                    staticClass: "pdp-set-picker__size-btn",
                    class: { "is-active": opt === _vm.selectedSize },
                    attrs: { type: "button", disabled: _vm.disabled },
                    on: {
                      click: function ($event) {
                        return _vm.selectSize(opt)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(opt.replace("x", " x ")) +
                        "\n      "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.needsSize && !_vm.disabled
              ? _c("span", { staticClass: "pdp-set-picker__size-hint" }, [
                  _vm._v("Pick one to continue"),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "footer", staticClass: "pdp-set-picker__footer" }, [
        _c(
          "div",
          {
            staticClass: "pdp-set-picker__create-split",
            class: { "is-open": _vm.createMenuOpen },
          },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-primary pdp-set-picker__create",
                attrs: { type: "button", disabled: !_vm.canCreate },
                on: {
                  click: function ($event) {
                    return _vm.confirm("parallel")
                  },
                },
              },
              [
                _c("i", { staticClass: "bi bi-lightning-charge-fill" }),
                _vm._v(
                  "\n        Create " +
                    _vm._s(_vm.localRows.length) +
                    " at once\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "pdp-set-picker__create-caret",
                attrs: {
                  type: "button",
                  disabled: !_vm.canCreate,
                  "aria-label": "More create options",
                },
                on: { click: _vm.toggleCreateMenu },
              },
              [_c("i", { staticClass: "bi bi-chevron-down" })]
            ),
            _vm._v(" "),
            _vm.createMenuOpen
              ? _c("div", { staticClass: "pdp-set-picker__create-menu" }, [
                  _c(
                    "button",
                    {
                      staticClass: "pdp-set-picker__create-menu-item",
                      attrs: { type: "button", disabled: !_vm.canCreate },
                      on: {
                        click: function ($event) {
                          return _vm.chooseCreate("parallel")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "bi bi-lightning-charge-fill" }),
                      _vm._v(
                        "\n          Create " +
                          _vm._s(_vm.localRows.length) +
                          " at once\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "pdp-set-picker__create-menu-item",
                      attrs: { type: "button", disabled: !_vm.canCreate },
                      on: {
                        click: function ($event) {
                          return _vm.chooseCreate("sequential")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "bi bi-arrow-right" }),
                      _vm._v("\n          One at a time\n        "),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.rowsNeedingOwnImage && !_vm.disabled
          ? _c("span", { staticClass: "pdp-set-picker__upload-hint" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.rowsNeedingOwnImage) +
                  "\n      " +
                  _vm._s(
                    _vm.rowsNeedingOwnImage === 1 ? "card needs" : "cards need"
                  ) +
                  " your image\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "pdp-set-picker__browse",
            attrs: { type: "button", disabled: _vm.disabled },
            on: {
              click: function ($event) {
                return _vm.$emit("open-gallery")
              },
            },
          },
          [_vm._v("\n      Browse full gallery →\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("AIChatWidgetPdpTemplateLightbox", {
        attrs: {
          visible: !!_vm.lightbox.visible,
          template: _vm.lightbox.template || {},
          "is-selected": _vm.lightbox.isSelected,
        },
        on: {
          "select-template": _vm.onLightboxSelect,
          "deselect-template": _vm.onLightboxDeselect,
          close: _vm.closeLightbox,
        },
      }),
      _vm._v(" "),
      _vm.imagePreview.visible
        ? _c(
            "div",
            {
              staticClass: "pdp-set-picker__preview-lightbox",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeImagePreviewModal.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "pdp-set-picker__preview-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.closeImagePreviewModal },
                },
                [_c("i", { staticClass: "bi bi-x-lg" })]
              ),
              _vm._v(" "),
              _c("img", {
                staticClass: "pdp-set-picker__preview-img",
                attrs: {
                  src: _vm.imagePreview.url,
                  alt: _vm.imagePreview.label,
                },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("b", [
      _c("i", { staticClass: "bi bi-stars pdp-set-picker__intro-icon" }),
      _vm._v(" AI"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "pdp-set-picker__direction-section-head" },
      [
        _c("span", { staticClass: "pdp-set-picker__direction-label" }, [
          _vm._v("Direction"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }